module.exports = __webpack_public_path__ + "static/media/hunter-cat-chip.f1b2093d.svg";